import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';

export class HubPageCardClickEvent implements ApplicationEvent {

  type = ApplicationEventType.HubPageCardClick;

  constructor(private payload: any) {}

  getPayload(): any {
    return {
      label: this.payload.label,
      gtmCustom: {
        'content-name': this.payload.gtmCustom['content-name']
      }
    };
  }
}
